import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Meal from '../Meal/Meal';
import {
  CategoryStyled,
  CategoryHeaderStyled,
  CategoryNameStyled,
  CategoryDescriptionStyled,
  MealCards,
  MealCardsLight
} from './Category.style';
import {ANALYTICS_EVENT_CATEGORIES} from '../../constants/constant';

export default class Category extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
    this.toggleCategoryMeals = this.toggleCategoryMeals.bind(this);
  }

  toggleCategoryMeals() {
    this.setState({isExpanded: !this.state.isExpanded});
  }

  render() {
    const {meals,
      category,
      showMealModal,
      addItemStraightToBasket,
      restaurantModes,
      isOfflineMenu,
      handleShowDisabledMealModal,
      serverOffline,
      isTemplateLight,
      handleOpenPictureModal
    } = this.props;
    const showMealAddButton = restaurantModes.onlineOrdering && !isOfflineMenu && !serverOffline;

    const mealsCards = category.mealUuids.map(uuid =>
      <Meal
        key={uuid}
        meal={meals[uuid]}
        showMealModal={showMealModal}
        handleShowDisabledMealModal={handleShowDisabledMealModal}
        addItemStraightToBasket={addItemStraightToBasket}
        restaurantModes={restaurantModes}
        isOfflineMenu={isOfflineMenu}
        showMealAddButton={showMealAddButton}
        showMealMoreButton={!showMealAddButton && (meals[uuid].sizes.length !== 1 || meals[uuid].sizes[0].optionGroups.length > 0)}
        serverOffline={serverOffline}
        parent={ANALYTICS_EVENT_CATEGORIES.MENU}
        handleOpenPictureModal={handleOpenPictureModal}
      />
    );

    const headerCard = (
      <CategoryHeaderStyled
        name={category.name}
        data-rw="menu-page--category-header"
        isExpanded={this.state.isExpanded}
        onClick={this.toggleCategoryMeals}
        isTemplateLight={isTemplateLight}
      >
        <CategoryNameStyled
          data-rw="menu-page--menu--category-header--title"
          isTemplateLight={isTemplateLight}
        >
          {category.name}
        </CategoryNameStyled>
        {
          category.description && <CategoryDescriptionStyled data-rw="menu-page--category-header--description">{category.description}</CategoryDescriptionStyled>
        }
      </CategoryHeaderStyled>
    );
    const renderMealCards = isTemplateLight
      ? (
        <MealCardsLight
          isExpanded={this.state.isExpanded}
          data-rw="menu-page--category-meal-list"
        >
          {mealsCards}
        </MealCardsLight>
      ) : (
        <MealCards
          isExpanded={this.state.isExpanded}
          data-rw="menu-page--category-meal-list"
        >
          {mealsCards}
        </MealCards>
      );
    return (
      <CategoryStyled
        data-rw="menu-page--category-component"
        data-rw-meta={`menu-page--category-header ${category.name}`}
      >
        {headerCard}
        {renderMealCards}
      </CategoryStyled>
    );
  }
}

Category.propTypes = {
  category: PropTypes.object.isRequired,
  meals: PropTypes.object.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  showMealModal: PropTypes.func.isRequired,
  handleShowDisabledMealModal: PropTypes.func,
  addItemStraightToBasket: PropTypes.func.isRequired,
  isOfflineMenu: PropTypes.bool.isRequired,
  serverOffline: PropTypes.bool.isRequired,
  isTemplateLight: PropTypes.bool.isRequired,
  handleOpenPictureModal: PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./components/Categories/Category.js